/**
 * Notification / meeting links may be either in-app paths ("/CalendarView")
 * or absolute URLs ("https://meet.google.com/…"). React Router's navigate()
 * treats the latter as a relative path, which produces
 * /EmployeeDashboard/https://meet.google.com/…
 */

const ABSOLUTE_HTTP = /^https?:\/\//i;
const PROTOCOL_RELATIVE = /^\/\//;
const KNOWN_MEET_HOST = /^(meet\.google\.com|zoom\.us|[\w.-]+\.zoom\.us|teams\.microsoft\.com|teams\.live\.com)\b/i;

export function isExternalHttpUrl(url) {
  const s = String(url || "").trim();
  if (!s) return false;
  if (ABSOLUTE_HTTP.test(s) || PROTOCOL_RELATIVE.test(s)) return true;
  return KNOWN_MEET_HOST.test(s);
}

export function resolveExternalUrl(url) {
  const s = String(url || "").trim();
  if (!s) return s;
  if (ABSOLUTE_HTTP.test(s)) return s;
  if (PROTOCOL_RELATIVE.test(s)) {
    const proto = typeof window !== "undefined" ? window.location.protocol : "https:";
    return `${proto}${s}`;
  }
  return `https://${s.replace(/^\/+/, "")}`;
}

export function openNotificationUrl(url, navigate) {
  if (!url) return;
  const raw = String(url).trim();
  if (isExternalHttpUrl(raw)) {
    const href = resolveExternalUrl(raw);
    if (typeof window !== "undefined") {
      window.open(href, "_blank", "noopener,noreferrer");
    }
    return;
  }
  const path = raw.startsWith("/") ? raw : `/${raw}`;
  if (typeof navigate === "function") navigate(path);
  else if (typeof window !== "undefined") window.location.assign(path);
}
